import PropTypes from 'prop-types';
import { Helmet } from 'core/libs/helmet';

import { imageVersionAttributes } from 'core/utils/prop-types/model';
import getImageUrl, { getMinValue, getSrc } from 'core/utils/smart-image';
import { isVideoMedia } from 'core/utils/content';

import { MOBILE_BIG, viewportBreakpoints } from 'core/components/breakpoint/viewport-values';

/**
 * Обетка над amp-img
 * Подробнее: https://www.ampproject.org/docs/reference/components/amp-img
 */
function AmpImage(props, context) {
  const {
    url,
    height,
    width,
    maxWidth,
    maxHeight,
    aspectRatio,
    dpr,
    layout,
    placeholder,
    alt,
    title,
  } = props;

  const src = getSrc(props);

  if (!url && !src) {
    return null;
  }

  /**
   * Определяем финальный размер картинки
   */
  let imageWidth = getMinValue(width, maxWidth);

  /**
   * Ограничиваем максимальную ширину картинкиK
   */
  const viewportMaxWidth = parseInt(viewportBreakpoints[MOBILE_BIG], 10);

  if (viewportMaxWidth && (!imageWidth || imageWidth > viewportMaxWidth)) {
    imageWidth = viewportMaxWidth;
  }

  const {
    webdavHost,
    thumborHost,
  } = context;

  const isVideo = isVideoMedia(src, url);

  const imageUrl = getImageUrl({
    src,
    url,
    width,
    height,
    maxWidth: imageWidth,
    maxHeight,
    aspectRatio,
    dpr,
    webdavHost,
    ...!isVideo && { thumborHost },
  });

  const mediaProps = {
    src: imageUrl,
    layout,
    height: height || src.height,
    width: width || src.width,
    alt,
  };

  return isVideo ? (
    <>
      <Helmet>
        <script
          async=''
          custom-element='amp-video'
          src='https://cdn.ampproject.org/v0/amp-video-0.1.js'
        />
      </Helmet>
      <amp-video
        {...mediaProps}
        muted=''
        loop=''
        autoplay=''
      />
    </>
  ) : (
    <amp-img
      {...mediaProps}
      placeholder={placeholder}
      title={title}
    />
  );
}

AmpImage.contextTypes = {
  webdavHost: PropTypes.string,
  thumborHost: PropTypes.string,
};

AmpImage.defaultProps = {
  layout: 'responsive',
  alt: '',
  version: 'original',
};

AmpImage.propTypes = {
  aspectRatio: PropTypes.number,
  src: imageVersionAttributes,
  layout: PropTypes.oneOf([
    'fill',
    'fixed',
    'fixed-height',
    'flex-item',
    'intrinsic',
    'nodisplay',
    'responsive',
  ]),
  height: PropTypes.number,
  maxHeight: PropTypes.number,
  width: PropTypes.number,
  maxWidth: PropTypes.number,
  url: PropTypes.string,
  dpr: PropTypes.number,
  placeholder: PropTypes.bool,
  alt: PropTypes.string,
  title: PropTypes.string,
};

export default AmpImage;
